import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

export const AboutUs = () => {

    return (
        <div className="AboutUs-Page">
            {/* Breadcrumb Banner Section */}
            <section className="breadcrumb-banner-section py-5">
                <div className="container-xl position-relative z-1">
                    <div className="page-header text-white text-uppercase text-center">
                        <div className="section-heading text-white lh-sm mb-2">About Us</div>
                        <ul className="list-unstyled d-flex justify-content-center gap-2 mb-0">
                            <li className="text-white">Home</li>
                            <li>
                                <span>/</span>
                            </li>
                            <li className="text-primary">About</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* About Us Section */}
            <section className="about-cmpny-sec bg-secondary bg-opacity-10 py-5">
                <div className="container-xl my-md-4">
                    <Row className="align-items-center gx-md-5 gy-4">
                        <Col lg={6}>
                            <div data-aos="slide-right" className="img-wrapper position-relative">
                                <img src={require('../assets/images/about-image-3.jpg')} className="img-fluid w-100" alt="About" />
                                <div className="img-frame position-absolute top-50 start-50 translate-middle z-1"></div>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div data-aos="slide-left" className="content-wrapper">
                                <div className="label-heading mb-2"><span className="badge bg-success fw-semibold">About Us</span></div>
                                <div className="section-heading mb-3">Empowering <span>learners</span> to speak <span>Language</span> confidently.</div>
                                <div className="our-mission-wrapper mb-4">
                                    <p>
                                        Yoospeak is an innovative Language learning app designed to empower learners to communicate confidently in any situation.
                                        From interactive lessons and practical exercises to guidance from skilled teachers, we make Language simple, engaging, and effective.
                                        Whether you’re preparing for interviews, improving workplace communication, or enhancing daily conversations, Yoospeak is your partner for success.
                                    </p>
                                    <p>
                                        Yoospeak makes Language learning simple, practical, and effective. Learn from skilled teachers, practice real-life scenarios,
                                        and gain the confidence to speak Language in interviews, at work, and every day.
                                    </p>
                                </div>
                                <div className="btn-wrapper mt-4">
                                    <button type="button" className="btn-custom btn btn-theme1">Learn More <i className="bi bi-arrow-right"></i></button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            {/* What is Yoospeak Section */}
            <section className="about-cmpny-sec py-5">
                <div className="container-xl my-md-4">
                    <div className="section-heading-wrapper">
                        <div className="section-heading">What is <span>Yoospeak?</span></div>
                        <div className="description">Yoospeak is an Language learning app designed to help students succeed at work, in interviews, and in daily life.</div>
                    </div>
                    <Row className="g-4">
                        <Col md={6} lg={4}>
                            <div data-aos="slide-right" className="item-wrapper h-100 bg-theme1 bg-opacity-25 border border-theme1 rounded-4 text-center px-4 py-5">
                                <div className="icon mb-4">
                                    <img src={require('../assets/images/mission.png')} alt="Mission" className="img-fluid" />
                                </div>
                                <div className="fs-4 fw-semibold text-dark mb-2">Mission</div>
                                <div className="fs-6 text-body text-opacity-75">At Yoospeak, we believe Language should be easy to learn and valuable in real life. Our mission is to make Language simple and useful for everyone.</div>
                            </div>
                        </Col>

                        <Col md={6} lg={4}>
                            <div data-aos="zoom-in-up" className="item-wrapper h-100 bg-success bg-opacity-25 border border-success rounded-4 text-center px-4 py-5">
                                <div className="icon mb-4">
                                    <img src={require('../assets/images/vision.png')} alt="Vision" className="img-fluid" />
                                </div>
                                <div className="fs-4 fw-semibold text-dark mb-2">Vision</div>
                                <div className="fs-6 text-body text-opacity-75">Our vision is to empower learners everywhere to communicate confidently and become part of a global Language-speaking community.</div>
                            </div>
                        </Col>

                        <Col md={6} lg={4}>
                            <div data-aos="slide-left" className="item-wrapper h-100 bg-danger bg-opacity-25 border border-danger rounded-4 text-center px-4 py-5">
                                <div className="icon mb-4">
                                    <img src={require('../assets/images/teacher.png')} alt="Teacher" className="img-fluid" />
                                </div>
                                <div className="fs-4 fw-semibold text-dark mb-2">Teachers</div>
                                <div className="fs-6 text-body text-opacity-75">Yoospeak connects learners with skilled and passionate Language teachers, providing guidance, feedback, and personalized support to help every student succeed.</div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            {/* Our Team Section */}
            <section className="our-team-sec bg-primary bg-opacity-10 py-5">
                <div className="container-xl my-md-4">
                    <div className="section-heading-wrapper pb-md-3">
                        <div className="section-heading">Meet The <span>Expert</span> Team</div>
                        <div className="description">Leaders, innovators, and professionals dedicated to shaping the future.</div>
                    </div>
                    <Row className="gx-md-5 gy-5">
                        <Col lg={3} sm={6}>
                            <div data-aos="slide-right" className="team-wrapper text-center">
                                <div className="img-wrapper position-relative p-3 p-md-4">
                                    <img src={require('../assets/images/team1.jpeg')} className="img-fluid" alt="Team Member" />
                                </div>
                                <div className="team-info text-center mt-3">
                                    <div className="name text-lg fw-semibold text-black text-capitalize mb-1">John Doe</div>
                                    <div className="designation small text-muted text-capitalize mb-2">Lead Frontend Designer (Senior Executive Multimedia)</div>
                                    <div className="social-wrapper d-flex align-items-center justify-content-center gap-3 mt-2">
                                        <Link to="https://www.facebook.com/" className="text-base text-primary"><i className="bi bi-facebook"></i></Link>
                                        <Link to="https://twitter.com/" className="text-base text-primary"><i className="bi bi-twitter"></i></Link>
                                        <Link to="https://www.instagram.com/" className="text-base text-primary"><i className="bi bi-instagram"></i></Link>
                                        <Link to="https://in.linkedin.com/" className="text-base text-primary"><i className="bi bi-linkedin"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={3} sm={6}>
                            <div data-aos="slide-right" className="team-wrapper text-center">
                                <div className="img-wrapper position-relative p-3 p-md-4">
                                    <img src={require('../assets/images/team2.jpeg')} className="img-fluid" alt="Team Member" />
                                </div>
                                <div className="team-info text-center mt-3">
                                    <div className="name text-lg fw-semibold text-black text-capitalize mb-1">Davin Martin</div>
                                    <div className="designation small text-muted text-capitalize mb-2">Developer (Supply chain, education tech, analytics)</div>
                                    <div className="social-wrapper d-flex align-items-center justify-content-center gap-3 mt-2">
                                        <Link to="https://www.facebook.com/" className="text-base text-primary"><i className="bi bi-facebook"></i></Link>
                                        <Link to="https://twitter.com/" className="text-base text-primary"><i className="bi bi-twitter"></i></Link>
                                        <Link to="https://www.instagram.com/" className="text-base text-primary"><i className="bi bi-instagram"></i></Link>
                                        <Link to="https://in.linkedin.com/" className="text-base text-primary"><i className="bi bi-linkedin"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={3} sm={6}>
                            <div data-aos="slide-left" className="team-wrapper text-center">
                                <div className="img-wrapper position-relative p-3 p-md-4">
                                    <img src={require('../assets/images/team3.jpeg')} className="img-fluid" alt="Team Member" />
                                </div>
                                <div className="team-info text-center mt-3">
                                    <div className="name text-lg fw-semibold text-black text-capitalize mb-1">Jason Mark</div>
                                    <div className="designation small text-muted text-capitalize mb-2">Designer (Supply chain, education tech, analytics)</div>
                                    <div className="social-wrapper d-flex align-items-center justify-content-center gap-3 mt-2">
                                        <Link to="https://www.facebook.com/" className="text-base text-primary"><i className="bi bi-facebook"></i></Link>
                                        <Link to="https://twitter.com/" className="text-base text-primary"><i className="bi bi-twitter"></i></Link>
                                        <Link to="https://www.instagram.com/" className="text-base text-primary"><i className="bi bi-instagram"></i></Link>
                                        <Link to="https://in.linkedin.com/" className="text-base text-primary"><i className="bi bi-linkedin"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={3} sm={6}>
                            <div data-aos="slide-left" className="team-wrapper text-center">
                                <div className="img-wrapper position-relative p-3 p-md-4">
                                    <img src={require('../assets/images/team4.jpeg')} className="img-fluid" alt="Team Member" />
                                </div>
                                <div className="team-info text-center mt-3">
                                    <div className="name text-lg fw-semibold text-black text-capitalize mb-1">Jason Phillip</div>
                                    <div className="designation small text-muted text-capitalize mb-2">Lead Architect (Supply chain, education tech, analytics)</div>
                                    <div className="social-wrapper d-flex align-items-center justify-content-center gap-3 mt-2">
                                        <Link to="https://www.facebook.com/" className="text-base text-primary"><i className="bi bi-facebook"></i></Link>
                                        <Link to="https://twitter.com/" className="text-base text-primary"><i className="bi bi-twitter"></i></Link>
                                        <Link to="https://www.instagram.com/" className="text-base text-primary"><i className="bi bi-instagram"></i></Link>
                                        <Link to="https://in.linkedin.com/" className="text-base text-primary"><i className="bi bi-linkedin"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            {/* Practice Together Section */}
            <section className="practice-together-section d-flex align-items-center overlay-wrapper py-5">
                <div className="container-xl my-4">
                    <div data-aos="zoom-in-up" className="content-wrapper position-relative text-center mx-auto" style={{ maxWidth: '750px' }}>
                        <div className="section-heading-wrapper mb-4">
                            <div className="section-heading text-white text-uppercase mb-3">Practice <span>Together</span>, Learn <span>Together</span></div>
                            <div className="description fs-6 text-white text-opacity-75 mb-4">Join a global community of learners and teachers, improving Language through interactive lessons, real-life practice, and shared growth.</div>
                        </div>
                        <div className="wrapper">
                            <div className="fs-5 fw-semibold text-white mb-3">Download Yoospeak App Now -</div>
                            <div className="app-btn-wrapper d-flex flex-wrap justify-content-center gap-3">
                                <Link className="text-md-end" to={'https://play.google.com/store/games'} target="_blank">
                                    <img src={require('../assets/images/play-store.png')} className="img-fluid rounded-3" alt='Google Play Store' />
                                </Link>
                                <Link to={'https://appstoreconnect.apple.com/login'} target="_blank">
                                    <img src={require('../assets/images/app-store.png')} className="img-fluid rounded-3" alt='App Store' />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
